import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service'
import { FileUploader } from 'ng2-file-upload';
import { UserModel } from './index';
import { Observable } from 'rxjs/Observable';
import { BASE_URL } from '../utils/index';
import { CnsltnFwdrModel } from './quotation.service';
import { Subscription } from 'rxjs/Subscription';
import { Line } from './transportation.service';
import { Location } from './locations.service';
import { CookieService} from 'ngx-cookie-service';
import { HttpHeaders } from '@angular/common/http';

declare var moment:any;

@Injectable()
export class ForwarderService {

  fwdrListSearchOption :any;
  fwdrListPager:any;
  fwdrListHeader:any;
  fwdrClickedHeader:any;

  fwdrOwnerSearchOption :any;
  fwdrOwnerPager:any;
  fwdrOwnerHeader:any;
  fwdrOwnerClickedHeader:any;

  fwdrLineSearchOption :any;
  fwdrLinePager:any;
  fwdrLineHeader:any;
  fwdrLineClickedHeader:any;

  farePortSearchOption :any;
  farePortPager:any;
  farePortHeader:any;
  farePortClickedHeader:any;


  constructor(private http: Http, private apiService:ApiService, private cookieService:CookieService) {};

  initSearch(){
    this.fwdrListSearchOption = null;
    this.fwdrListPager = null;
    this.fwdrListHeader = null;
    this.fwdrClickedHeader = null;
  }

  initSearch2(){
    this.fwdrOwnerSearchOption = null;
    this.fwdrOwnerPager = null;
    this.fwdrOwnerHeader = null;
    this.fwdrOwnerClickedHeader = null;
  }
  getCorpInfo(corpId:number) {
    return this.apiService.get('admin/corps/' + corpId);
  }

  getSpecialItemList() {
    return this.apiService.get('forwarder/speciality-items');
  }

  getLicenseItemList() {
    return this.apiService.get('forwarder/license-items');
  }

  findRegNo(corpRegNo) {
    return this.apiService.get('corp/corp-reg-no', {corpRegNo: corpRegNo});
  }

  postCorpLogo(corpId:number, uploader:FileUploader) {
    uploader.setOptions({
      url: BASE_URL + 'admin/corps/' + corpId + '/logo',
      headers: [
        {name: 'tx-clientid', value : 'tradlinx'},
        {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
      ]
    });
    uploader.queue.forEach((elem) => {
      elem.alias = 'logoFile';
    });
    uploader.uploadAll();
  }

  postCorpReg(corpId:number, uploader:FileUploader) {
    uploader.setOptions({
      url: BASE_URL + 'admin/corps/' + corpId + '/corp-reg-no',
      headers: [
        {name: 'tx-clientid', value : 'tradlinx'},
        {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
      ]
    });
    uploader.queue.forEach((elem) => {
      elem.alias = 'corpRegNo';
    });
    uploader.uploadAll();
  }

  postCorpInfo(corpId, corpInfo) {
    return this.apiService.post('admin/corps/'+corpId, corpInfo, true);
  }

  

  delCorpReg(corpId, corpRegNo) {
    return this.apiService.post('admin/corps/'+corpId+'/corp-reg-no/' + corpRegNo);
  }

  getRegions() {
    return this.apiService.get('region');
  }

  // ============================================
  getCorpUsersbyCorpId(corpId) {
    return this.apiService.get('user/v2/corp-user-inner?corp-id=' + corpId);
  }
  getUsersNotCorpUser() {
    return this.apiService.get('user/v2/corp-user-inner/not-corp-user');
  }


  getFwdrCfsList(corpId) {
    return this.apiService.get('admin/fwdr/' + corpId + '/cfs');
  }

  postCfsList(cfsList, corpId) {
    return this.apiService.post('admin/fwdr/' + corpId + '/cfs/', {cfsList: cfsList}, true);
  }

  deleteCfsList(corpId:number, cfsId:number){
    return this.apiService.post('admin/fwdr/' + corpId + '/cfs/' + cfsId);
  }

  postEmployeeList(empList, corpId) {
    let body = {
      emails: empList
    };
    return this.apiService.post('user/v2/corp-user-inner/invitation/' + corpId, body, false);
  }

  getCorpList(){
		return this.apiService.get('admin/corps');
  }
  
  getFareAuthCorpList() {
    return this.apiService.get('admin/corps/fareAuth');
  }

	updateFwdrCorpStatusCd(fwdr:Corporation):Observable<any>{
		return this.apiService.post('admin/corps/' + fwdr.corpId + '/status', fwdr, true);
  }
  
  // delEmployeeUser(corpId:number, employeeId:number){
  //   return this.apiService.del('admin/fwdr/' + corpId + '/employees/' + employeeId);
  // }

  // updFwdrEmployeeStusCd(corpId:number, employeeId:number, employee){
  //   return this.apiService.post('admin/fwdr/' + corpId + '/employees/' + employeeId, employee, true);
  // }

  deleteFwdrEmployee(corpId:number, email: string) {
    return this.apiService.delReqParamsType('user/v2/corp-user-inner/invitation', {'corp-id': corpId, 'email': email});
  }

  postCorpContract(corpId, contract) {
    return this.apiService.post('admin/corps/' + corpId + '/contract', contract, true);
  }

  getPromotion(corpId){
    return this.apiService.get('admin/corps/' + corpId  + '/banner');
  }

  postPromotion(corpId, promotion) {
    return this.apiService.post('admin/corps/' + corpId  + '/banner', promotion, true);
  }

  postBannerStatus(corpId, promotion) {
    return this.apiService.post('admin/corps/' + corpId  + '/banner/status', promotion, true);
  }

  deletePromotion(corpId, bannerId) {
    return this.apiService.delReqParamsType('admin/corps/' + corpId + '/banner/' + bannerId);
  }

  postPromotionActive(corpId, banner) {
    return this.apiService.post('admin/corps/'+ corpId + '/banner/activity', banner, true);
  }

  getReqModifyTempList(corpId:number){
    return this.apiService.get('admin/corps/' + corpId + '/temps');
  }

  getCorpInfoTemp(corpTempId:number){
    return this.apiService.get('admin/corp/temps/' + corpTempId);
  }

  postApprovalCorpTemp(corpTempId:number, corpInfo){
    return this.apiService.post('admin/corp/temps/' + corpTempId, corpInfo, true);
  }

  getCorpInfoForCnsltnSetting(corpInfo:number){
    return this.apiService.get('admin/corps/'+ corpInfo +'/cnsltn');
  }

  postCorpInfoForCnsltnSetting(corpId, corpInfo) {
    return this.apiService.post('admin/corps/'+ corpId + "/cnsltn", corpInfo, true);
  }
  
  getFwdrsWithCnsltnRegionAndSpeciality(){
    return this.apiService.get('admin/consult/corps/fwdrs');
  }

  changeCorpRegUser(corpId:number, userId:number){
    return this.apiService.patchReqBodyType('admin/corps/' + corpId + '/regUser', {corpId:corpId, userId:userId});
  }

  delCorpRegUser(corpId:number) {
    return this.apiService.patchReqBodyType('admin/corps/' + corpId + '/cancelRegUser', {corpId: corpId});
  }

  getRequestCorpOwnerList() {
    return this.apiService.get('admin/corp/requestOwner/list');
  }

  patchRequestOwner(userId) {
    return this.apiService.patchReqBodyType('admin/corp/requestOwner/' + userId)
  }

  getFwdrLineList(callback?: (value: AnnouncedfareFwdrList[]) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.getInnerTargetApi('announcedfare/entrps', null, callback, error, complete);
  }
  
  postFwdrLineList(fwdrLineList: AnnouncedfareFwdrReqBody[], callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.postInnerTargetApi('announcedfare/entrps', fwdrLineList, callback, error, complete);
  }
  
  getFarePortList(callback?: (value: AnnouncedfarePortList[]) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.getInnerTargetApi('announcedfare/port', null, callback, error, complete);
  }
  
  postFarePortList(farePortList: AnnouncedfarePortReqBody[], callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.postInnerTargetApi('announcedfare/port', farePortList, callback, error, complete);
  }
  
  patchFareLineHide(entrpsNm:string, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.patchInnerTargetApi('announcedfare/entrps/' + entrpsNm + '/hide', null, callback, error, complete);
  }

  patchFareLineShow(entrpsNm:string, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.patchInnerTargetApi('announcedfare/entrps/' + entrpsNm + '/show', null, callback, error, complete);
  }

  patchFarePortHide(portMapId:string, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.patchInnerTargetApi('announcedfare/port/' + portMapId + '/hide', null, callback, error, complete);
  }

  patchFarePortShow(portMapId:string, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.patchInnerTargetApi('announcedfare/port/' + portMapId + '/show', null, callback, error, complete);
  }

  getCorpFiles(corpId, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.getInnerTargetApi('corporation/file/' + corpId, null, callback, error, complete);
  }

  postCorpFiles(corpId, file, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription {
    return this.apiService.postInnerTargetApi('corporation/file/' + corpId, file, callback, error, complete, true);
  }

  delCorpFile(corpId, corpFileId, callback?: (value: any) => void, error?: (error) => void, complete?: () => void): Subscription {
    return this.apiService.delInnerTargetApi('corporation/file/' + corpId, { corpFileId : corpFileId }, callback, error, complete);
  }

  postOceanLineServiceRoutes(corpId: number, routes: string[]) {
    return this.apiService.post('lingo/ocean-line/'+ corpId + '/service-route', {routes : routes});
  }

  getOceanLineServiceRoutes(corpId: number) {
    return this.apiService.get('lingo/ocean-line/'+ corpId + '/service-route');
  }
}  


export class AnnouncedfarePortReqBody {
  locationId: string;
  portMapId: string;
}


export class AnnouncedfarePortList {
  line: AnnouncedfareLine;
  lineCd: string;
  location: Location;
  portCd: string;
  portMapId: string;
  portNm: string;
  selectedLocationId:string;
  selectedLocation:Location;
  hideYn:string;
}

export class AnnouncedfareFwdrReqBody {
  entrpsNm: string;
  lineCd: string;
}
export class AnnouncedfareFwdrList {
  checkDtm: string;
  checkUserId: string;
  delDtm: string;
  delUserId: string;
  delYn: string;
  entrpsNm: string;
  line: AnnouncedfareLine
  lineCd: string;
  hideYn:string;
  selectedLine:Line;
}

export class AnnouncedfareLine {
  lineCd: string;
  lineNm: string;
  lineNm2: string;
  lineNmKr: string;
}

export class CorpIdNm {
  corpId: number;
  corpNm: string;
}
export class CorpInfo {
  isReqModify:number;
  address:string;
  addressDtl:string;
  ceo:string;
  corpId: number;
  corpNm:string;
  corpRegFile: string;
  corpRegFileNm: string;
  corpRegNo:string;
  displayTeuYn:string;
  refreshDataYn:string;
  establishYy:string;
  fax:string;
  licenseList: Array<License> = new Array();
  logoFile:string;
  logoFileNm: string;
  officeList: Array<Office> = new Array();
  regionList: Array<Region> = new Array();
  sales: number;
  shipperList: Array<Shipper> = new Array();
  specialityList: Array<Speciality> = new Array();
  staffList: Array<Staff> = new Array();
  statusCd: number;
  statusNm: string;
  tel: string;
  typeCd: number = 1;
  typeNm: string;
  url: string;
  zip:string;
  regUser: UserModel;
  corpIntrdc:string;

  liner:Liner;
  contactList: Array<Contact> = new Array();

  isPartner:number = 0;
  isAuth:number = 0;
  isFare:number = 0;
  isCnsltn:number = 0;

  linerCd:string;
}

export class CorpInfoTemp extends CorpInfo{
  corpTempId:number;
  tempStatusCd:number;
  reqUser:UserModel;
  reqDtm:string;
}

export class Liner {
  lineCd:string;
  lineNm:string; 
  lineNm2:string;
  lineNmKr:string;
  alliance:string;
  cntryCd:string;
  cntryNm:string;
  corpId:number;
}

export class Contact {
	shprCd:string;
	shprNm:string;
	seq:number;
	location:string;
	teamNm:string;
	job:string;
	position:string;
	name:string;
	tel:string;
	email:string;
	fax:string;
}

export class Contact2 {
  constructor(shprCd:string, shprNm:string, seq:number){
    this.shprCd = shprCd;
    this.shprNm = shprNm;
    this.seq = seq;
  }
  isChecked: boolean;
	shprCd:string;
	shprNm:string;
	seq:number;
	location:string;
	teamNm:string;
	job:string;
	position:string;
	name:string;
	tel:string;
	email:string;
	fax:string;
}

export class License {
  licenseId: number;
  itemId:number; 
  itemNm: string;
  licenseRemark: string;
  remark: string;
}

export class License2 {
  isChecked: boolean;
  licenseId: number;
  itemId:number; 
  itemNm: string;
  licenseRemark: string;
  remark: string;
}

export class Shipper {
  commodityNm: string;
  corpId: number;
  shipperId: number;
  shipperNm: string;
}

export class Shipper2 {
  isChecked: boolean;
  commodityNm: string;
  corpId: number;
  shipperId: number;
  shipperNm: string;
}


export class Speciality {
  itemId: number;
  itemNm: string;
  itemRemark: string;
  itemTpCd: number;
  itemTpNm: string;
  remark: string;
  specialityId: number;
  purposeCd:number;
}

export class Office {
  address: string;
  corpId: number;
  fax: string;
  officeId: number;
  officeNm: string;
  tel: string;
  email:string;
  typeCd: number;
  typeNm: string;
}

export class Office2 {
  isChecked: boolean;
  address: string;
  corpId: number;
  fax: string;
  officeId: number;
  officeNm: string;
  tel: string;
  typeCd: number;
  typeNm: string;
}

export class Region {
  childList: Array<Region>;
  code: string;
  name: string;
  regionId: number;
  remark: string;
  typeCd: number;
  typeNm: string;
  purposeCd:number;
}

export class Staff {
  employeeId: number;
  corpId: number;
  userId: number;
  officeId: number;
  officeNm: string;
  region: string;
  jobTp: string;
  job: string;
  position: string;
  name: string;
  tel: string;
  mobile: string;
  fax: string;
  email: string;  
}

export class Staff2 {
  email: string;
  name: string;
  rankTp: string;
  rankTxt: string;
  status: string;
  tel: string;
  userId: number;
  // employeeId: number;
  // corpId: number;
  // userId: number;
  // officeId: number;
  // officeNm: string;
  // region: string;
  // jobTp: string;
  // job: string;
  // position: string;
  // name: string;
  // tel: string;
  // mobile: string;
  // fax: string;
  // email: string;
  // isChecked: boolean;
  // stusCd:number;
}

export class Corporation {
  corpId:number;        
  corpRegNo: string;    
  corpNm: string;       
  typeCd: number;       
  typeNm: string ;      
  ceo: string;          
  establishYy: string ; 
  url: string ;         
  sales:number;         
  tel: string ;         
  fax: string ;         
  address: string ;     
  addressDtl: string ;  
  zip: string ;         
  corpRegFile: string ; 
  corpRegFileNm: string;
  logoFile: string ;
  logoFileNm: string;    
  statusCd: number;     
  statusNm: string ;    
  corpIntrdc: string ;  
  regUser: UserModel;   
  isPartner: number;
  isReqModify: number;
  priorityNum: number;
  isFare: number;
  isCnsltn: number;
}

export class RequestOwner {
  address: string;
  addressDtl: string;
  ceo: string;
  corpId: number;
  corpInfo: {corpId: number, corpNm: string, corpRegNo: string}
  corpNm: string;
  corpRegFile: string;
  corpRegFileNm: string;
  corpRegNo: string;
  establishYy: string;
  fax: string;
  ownerReuqestUserInfo: OwnerUserInfo;
  email: string;
  firstNm: string;
  fullName: string;
  lastNm: string;
  tel: string;
  statusCd: string;
  url: string;
}

export class OwnerUserInfo {
  lastNm: string;
  firstNm: string;
  email: string;
  tel: string;
  fullName: string;
  userId:number;
}

export class Corporation2 extends Corporation{
  isChecked: boolean;
}

export class CnsltnFwdr {
  corpNm:string;
  reqNo:string;
  corpId:number;
  regUser: UserModel;
  corpRegNo: string;
  isImpssible:number = 0;
  stusCd:number = 0;
  delYn:number = 0;
}

export class Forwarder extends CorpInfo {
  isChecked: boolean;
}

export class CorpFile {
  corpFileId: number;
  corpId: number;
  delDtm: string;
  delUserId: number;
  delYn: string;
  fileName: string;
  fileTitle: string;
  insDtm: string;
  insUserId: number;
  storedFileName: string;

  type:string;
  fileType:string;
}


// WEBPACK FOOTER //
// ./src/app/services/forwarder.service.ts